
    import '/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/store.zh.md?watch=parent';
    export const demoIndex = {
  ids: [],
  getter: () => import(/* webpackChunkName: "meta__docs__zh" */'/Users/gaofuhong/X6-v2/sites/x6-sites/docs/xflow/store.zh.md?type=demo')
};